import React from "react";
import styles from "./index.module.scss";
import Image from "next/image";
import BlessLogo from "@public/horizontal-color-cropped.png";

type Props = {
  text: string;
};

const ServiceHeader = ({ text }: Props) => {
  return (
    <div className={styles.serviceHeaderContainer}>
      <div className={styles.serviceHeader}>
        <Image src={BlessLogo} alt={"Blessnet logo"} width={300} height={50} />
        <h4 className={styles.serviceText}>{text}</h4>
      </div>
    </div>
  );
};

export default ServiceHeader;
